import { render, staticRenderFns } from "./CreateServer.vue?vue&type=template&id=a3a0b890&scoped=true&"
import script from "./CreateServer.vue?vue&type=script&lang=js&"
export * from "./CreateServer.vue?vue&type=script&lang=js&"
import style0 from "./CreateServer.vue?vue&type=style&index=0&id=a3a0b890&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a0b890",
  null
  
)

export default component.exports